export class StatsFilter {
    serverPlayerNumber: number = null;
    rallyLength = '';
    serveLocation = '';
    returningSide = '';
    pointsPlayer1 = '';
    pointsPlayer2 = '';
}
